export default __webpack_public_path__ + "static/media/1468.a8a48572.png";